import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Table,
  Row,
  Col,
  CardTitle,
  CardText,
} from "reactstrap";
import classnames from "classnames";
import img from "../../assets/img/brand/goodybuddy_short.png";
import adminModel from "models/admin.model";
import { helper } from "lib/helper";
import BuddyInformation from "./buddyInformation";
import AllBooking from "./allBooking";
import RatingExperience from "./ratingExperience";
import ExperienceReports from "./experienceReports";
import experienceModel from "models/experience.model";
import AddButton from "components/Button/AddButton";
import BackButton from "components/Button/BackButton";

const ExperienceDetails = ({ edit }) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const initialExperience = location.state?.experience || {};
  const [activeTab, setActiveTab] = useState("1");
  const { id } = useParams();

  const navigate = useNavigate();

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [experience, setExperience] = useState([]);

  const getListData = async () => {
    setIsLoading(true);
    console.log(id, "id");
    await experienceModel
      .experienceDetails(id)
      .then((result) => {
        console.log(result.data, "experience");
        setIsLoading(false);
        if (result) {
          setExperience(result?.data?.data[0]);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  const convertTimeToHoursAndMinutes = (time) => {
    if (!time || typeof time !== "string" || !time.includes(":")) {
      return "Invalid time format";
    }
    const [hours, minutes] = time.split(":").map(Number);
    return `${hours} hour${hours > 1 ? "s" : ""} and ${minutes} minute${minutes > 1 ? "s" : ""}`;
  };


  // console.log(experience,"+++++++++++++++")

  useEffect(() => {
    getListData();
  }, [location]);

  console.log(experience, "experience");

  return (
    <Container className="pt-7" fluid>
      <Card className="shadow">
        <CardHeader>
          <Nav tabs>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggle("1")}
              >
                Basic Information
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggle("2")}
              >
                Buddy Information
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "3" })}
                onClick={() => toggle("3")}
              >
                All Bookings
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "4" })}
                onClick={() => toggle("4")}
              >
                Ratings and Reviews
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "5" })}
                onClick={() => toggle("5")}
              >
                Reported by user
              </NavLink>
            </NavItem>

          </Nav>
        </CardHeader>
        <CardBody>
          {activeTab === "1" && (
            <Row>
              <Col xs="12">

                <CardBody>
                  <CardTitle tag="h1" className="text-center mb-4">
                    Experience Details
                  </CardTitle>

                  <Row>
                    <Col md="6" className="mb-4">
                      <Card className="h-100 shadow">
                        <CardBody>
                          <CardTitle tag="h5" className="m-0 mb-3 font-bold border-bottom text-center pb-2">Experience offers</CardTitle>

                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Activities:</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.coreActivities
                              }
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Other Activities :</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.otherActivities
                                ?.map((item, index) => item)
                                .join(", ")}
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Goods :</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.goods
                                ?.map((item, index) => item)
                                .join(", ")}
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Services:</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.goodsOrServices
                                ?.map((item, index) => item)
                                .join(", ")}
                            </Col>
                          </Row>

                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="6" className="mb-4">
                      <Card className="h-100 shadow">
                        <CardBody>
                          <CardTitle tag="h5" className="m-0 mb-3 font-bold border-bottom text-center pb-2">Location Details</CardTitle>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Arrival Spot Location:</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.arrivalLocation?.flatNo} {experience?.arrivalLocation?.streetAddress}, {experience?.arrivalLocation?.city} , {experience?.arrivalLocation?.state} , {experience?.arrivalLocation?.country} , {experience?.arrivalLocation?.zipCode}
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Experience Spot Location:</strong>
                            </Col>
                            <Col xs="7">{experience?.location?.flatNo} {experience?.location?.streetAddress} , {experience?.location?.city} , {experience?.location?.state} , {experience?.location?.country} , {experience?.location?.zipCode} </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6" className="mb-4">
                      <Card className="h-100 shadow">
                        <CardBody>
                          <CardTitle tag="h5" className="m-0 mb-3 font-bold border-bottom text-center pb-2">Duration and Price</CardTitle>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Duration:</strong>
                            </Col>
                            <Col xs="7">
                              {convertTimeToHoursAndMinutes(experience?.duration)}
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Price per Person:</strong>
                            </Col>
                            <Col xs="7">Rs. {experience?.price}</Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>What will happen:</strong>
                            </Col>
                            <Col xs="7">{experience?.description?.length > 100 ? experience?.description.slice(0, 100) + "..." : experience?.description}</Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="6" className="mb-4">
                      <Card className="h-100 shadow">
                        <CardBody>
                          <CardTitle tag="h5" className="m-0 mb-3 font-bold border-bottom text-center pb-2">Designed</CardTitle>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Intended Audience:</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.intendedAudience
                                ?.map((item, index) => item?.name)
                                .join(", ")}
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Group Size:</strong>
                            </Col>
                            <Col xs="7">{experience?.maxGroupSize}</Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Event type:</strong>
                            </Col>
                            <Col xs="7">{experience?.typeOfHosting || "Open event"}</Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6" className="mb-4">
                      <Card className="h-100 shadow">
                        <CardBody>
                          <CardTitle tag="h5" className="m-0 font-bold border-bottom text-center pb-2 mb-3">Vibes</CardTitle>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Place Vibe:</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.placeVibes
                                ?.map((item, index) => item?.name)
                                .join(", ")}
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Activity Vibe:</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.activityVibes
                                ?.map((item, index) => item?.name)
                                .join(", ")}
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Buddy Vibe:</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.buddyVibes
                                ?.map((item, index) => item?.name)
                                .join(", ")}
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="6" className="mb-4">
                      <Card className="h-100 shadow">
                        <CardBody>
                          <CardTitle tag="h5" className="m-0 font-bold border-bottom text-center pb-2 mb-3">Experience Enhancements</CardTitle>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Entry Elements:</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.enhanceEntry
                                ?.map((item, index) => item)
                                .join(", ")}
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Surprise Gifts:</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.gifts
                                ?.map((item, index) => item)
                                .join(", ")}
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col xs="5">
                              <strong>Exit Elements:</strong>
                            </Col>
                            <Col xs="7">
                              {experience?.enhanceExit
                                ?.map((item, index) => item)
                                .join(", ")}
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  {/* <Row>
            <Col xs="12" className="mb-4">
              <Card className="shadow">
                <CardBody>
                  <CardTitle tag="h5" className="mb-3">Additional Details</CardTitle>
                  <Row className="mb-2">
                    <Col xs="4">
                      <strong>Your Commitment:</strong>
                    </Col>
                    <Col xs="8">
                      {experience?.commitments
                        ?.map((item, index) => item?.name)
                        .join(", ")}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row> */}


                  <div className="d-flex justify-content-between align-items-center">
                    <BackButton />
                    <AddButton title='Edit Details' onClick={() =>
                      navigate(
                        `/admin/listings/edit-experience-details/${id}`
                      )
                    } />
                  </div>
                  {/* <Button
            className="mt-2"
            color="primary"
            
          >
            Edit Details
          </Button> */}
                </CardBody>
              </Col>
            </Row>
          )}

          {activeTab === "2" && <BuddyInformation experience={experience} />}

          {activeTab === "3" && <AllBooking />}

          {activeTab === "4" && <RatingExperience />}

          {activeTab === "5" && <ExperienceReports />}


        </CardBody>
      </Card>
    </Container>
  );
};

export default ExperienceDetails;
